import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../../styles/colors';
import { InputBackground, InputInnerWrapper, InputWrapper, StyledInput } from './Input';
import { LinkLabel } from './LinkLabel';

export interface PasswordInputProps {
  id: string;
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: string;
  link?: {
    text: string;
    route?: string;
    actionFn?: () => void;
  };
  onKeyUp?: (event: any) => void;
  inputRef?: any;
}

const StyledPasswordInput = styled(StyledInput)`
  color: ${Colors.primaryLight};
  font-family: sans-serif;
  font-size: 1.5rem;

  :-webkit-autofill,
  :-webkit-autofill:hover,
  :-webkit-autofill:focus {
    color: ${Colors.primaryLight};
  }
`;
export const PasswordInput: FC<PasswordInputProps> = (props) => {
  return (
    <InputWrapper>
      {props.link ? <LinkLabel ignoreTabIndex for={props.id} label={props.label} link={props.link} /> : <LinkLabel for={props.id} label={props.label} />}
      <InputInnerWrapper>
        <InputBackground />
        <StyledPasswordInput
          id={props.id}
          type={`password`}
          autoComplete="current-password"
          placeholder={`${props.placeholder ? props.placeholder : 'Hier eingeben'}`}
          value={props.value}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            props.onChange(event.target.value);
          }}
          onKeyUp={props.onKeyUp}
          ref={props.inputRef}
        />
      </InputInnerWrapper>
    </InputWrapper>
  );
};
